import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from "./store";

interface User {
    userId: number
    firstName: string
    lastName: string
    userName: string
    bearerToken: string
}

const initialUser: User = {
    bearerToken: "", firstName: "", lastName: "", userId: 0, userName: ""
}

interface UserState {
    user: User
    fcm_token: { saved: boolean, token: string }
    counter: number
}

const initialState: UserState = {
    counter  : 0,
    fcm_token: {saved: false, token: ""},
    user     : initialUser
}

const userSlice = createSlice({
    name    : 'user', initialState,
    reducers: {
        updateUser    : (state: Draft<typeof initialState>, action: PayloadAction<User>) => {
            state.user = action.payload
        },
        lockUser      : (state: Draft<typeof initialState>) => {
            state.user.bearerToken = ""
        },
        logoutUser    : (state: Draft<typeof initialState>) => {
            state.user = initialUser
            state.fcm_token.saved = false
        },
        updateFCMToken: (state: Draft<typeof initialState>, action: PayloadAction<{ saved: boolean, token: string }>) => {
            state.fcm_token = action.payload
        },
        updateCounter : (state: Draft<typeof initialState>, action: PayloadAction<number>) => {
            state.counter = action.payload
        },
    },
});

// Selectors
export const getUser = (state: RootState) => state.user.user
export const getCounter = (state: RootState) => state.user.counter
export const getFCMToken = (state: RootState) => state.user.fcm_token

// Reducers and actions
export const {updateUser, updateCounter, updateFCMToken, logoutUser, lockUser} = userSlice.actions

export default userSlice.reducer